<div class="d-flex gap-2 align-items-center">
    <div class="grid-status" [ngClass]="['--' + text, !isBullet ? 'no-bullet' : '']">
        @if(isBullet){<img [src]="ICONS.BULLET" />}
        <span>{{data?.statusValue}}</span>
    </div>
    <div class="text-disc-renderer">
        <p class="link-icon text-link" (click)="onActionClick($event)">
            {{ actionText }}
            @if(isIcon){<img class="icon-info" [src]="ICONS.CHEVRON_RIGHT" />}
        </p>
    </div>
</div>